import { createContext, useContext, useState } from "react";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {

  const [filterOptions, setFilterOptions] = useState({});
  const [filterChips, setFilterChips] = useState([]);

  const [activeFilters, setActiveFilters] = useState({
    Company: [],
    Category: [],
    Brand: [],
    "Sub-Brand": [],
    "Route to Market": [],
    Channel: []
  });

  return (
    <FilterContext.Provider
      value={{
        filterOptions,
        setFilterOptions,
        filterChips,
        setFilterChips,
        activeFilters,
        setActiveFilters
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => useContext(FilterContext);
